import { FragmentViewMode } from '@app/modules/fragments/stores/fragments-settings.store';
import { createContext, useContext } from 'react';

/**
 * Breakpoint flags from MUI theme.breakpoints.up() (e.g. isMd = viewport >= md).
 */
export type BreakpointsUp = {
  isSm: boolean;
  isMd: boolean;
  isLg: boolean;
  isXl: boolean;
};

export type FragmentGridContextValue = {
  isVideo: boolean;
  breakpointsUp: BreakpointsUp;
  viewMode: FragmentViewMode;
};

export const FragmentGridContext = createContext<FragmentGridContextValue | null>(null);

/**
 * Consumes FragmentGridContext. Must be used within FragmentGridContext.Provider (i.e. inside FragmentsGrid).
 */
export function useFragmentGridContext(): FragmentGridContextValue {
  const value = useContext(FragmentGridContext);
  if (value == null) {
    throw new Error('useFragmentGridContext must be used within FragmentGridContext.Provider');
  }
  return value;
}
